import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SnackTheme } from '@main/snackbar/const';
import { SnackbarFacade } from '@main/snackbar/data-access';
import { SearchOrderDocumentParams, SearchOrderDocumentResult } from '@my-account/const';
import {
  MyAccountActions,
  MyAccountSelectors,
  OrderDocumentApiService,
  StateWithMyAccount,
} from '@my-account/data-access';
import { Store } from '@ngrx/store';
import { Observable, throwError } from 'rxjs';
import { catchError, distinctUntilChanged } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class OrderDocumentService {
  constructor(
    private store: Store<StateWithMyAccount>,
    private orderDocumentApiService: OrderDocumentApiService,
    private snackbarFacade: SnackbarFacade,
  ) {}

  search(params: SearchOrderDocumentParams): void {
    this.store.dispatch(new MyAccountActions.SearchOrderDocument(params));
  }

  getSearchValue(): Observable<SearchOrderDocumentResult> {
    return this.store.select(MyAccountSelectors.getSearchOrderDocumentValue).pipe(distinctUntilChanged());
  }

  getSearchLoading(): Observable<boolean> {
    return this.store.select(MyAccountSelectors.getSearchOrderDocumentLoading);
  }

  getSearchSuccess(): Observable<boolean> {
    return this.store.select(MyAccountSelectors.getSearchOrderDocumentSuccess);
  }

  getSearchError(): Observable<boolean> {
    return this.store.select(MyAccountSelectors.getSearchOrderDocumentError);
  }

  resetSearchState(): void {
    this.store.dispatch(new MyAccountActions.SearchOrderDocumentReset());
  }

  download(documentId: string): Observable<HttpResponse<Blob>> {
    return this.orderDocumentApiService.download(documentId).pipe(
      catchError((e) => {
        this.snackbarFacade.setSnack({
          theme: SnackTheme.Yellow,
          title: 'Ошибка',
          text: 'При загрузке данных произошла ошибка, повторите попытку позже, или обратитесь к вашему менеджеру',
        });

        return throwError(() => e);
      }),
    );
  }
}
